// Auth
export const SIGN_IN_ADMIN = 'SIGN_IN_ADMIN'
export const SIGN_OUT_ADMIN = 'SIGN_OUT_ADMIN'

export const ADMIN_CONTRACTOR = 'ADMIN_CONTRACTOR'
export const ADMIN_CONTRACTOR_CONDITION = 'ADMIN_CONTRACTOR_CONDITION'
export const ADMIN_CONTRACTOR_RESET_CONDITION = 'ADMIN_CONTRACTOR_RESET_CONDITION'
export const ADMIN_CONTRACTOR_RESET_PAGINATION = 'ADMIN_CONTRACTOR_RESET_PAGINATION'

export const ADMIN_TENANT = 'ADMIN_TENANT'
export const ADMIN_TENANT_CONDITION = 'ADMIN_TENANT_CONDITION'

export const ADMIN_NOTIFICATION = 'ADMIN_NOTIFICATION'
export const ADMIN_NOTIFICATION_CONDITION = 'ADMIN_NOTIFICATION_CONDITION'
export const ADMIN_NOTIFICATION_RESET_CONDITION = 'ADMIN_NOTIFICATION_RESET_CONDITION'
export const ADMIN_NOTIFICATION_RESET_PAGINATION = 'ADMIN_NOTIFICATION_RESET_PAGINATION'

export const ADMIN_TOPIC = 'ADMIN_TOPIC'
export const ADMIN_TOPIC_CONDITION = 'ADMIN_TOPIC_CONDITION'
export const ADMIN_TOPIC_RESET_CONDITION = 'ADMIN_TOPIC_RESET_CONDITION'
export const ADMIN_TOPIC_RESET_PAGINATION = 'ADMIN_TOPIC_RESET_PAGINATION'

export const ADMIN_DXE_NOTIFICATION = 'ADMIN_DXE_NOTIFICATION'
export const ADMIN_DXE_NOTIFICATION_CONDITION = 'ADMIN_DXE_NOTIFICATION_CONDITION'

export const ADMIN_USER = 'ADMIN_USER'
export const ADMIN_USER_CONDITION = 'ADMIN_USER_CONDITION'
export const ADMIN_USER_RESET_CONDITION = 'ADMIN_USER_RESET_CONDITION'
export const ADMIN_USER_RESET_PAGINATION = 'ADMIN_USER_RESET_PAGINATION'

export const ADMIN_TENANT_USER = 'ADMIN_TENANT_USER'
export const ADMIN_TENANT_USER_CONDITION = 'ADMIN_TENANT_USER_CONDITION'
export const ADMIN_TENANT_USER_RESET_CONDITION = 'ADMIN_TENANT_USER_RESET_CONDITION'
export const ADMIN_TENANT_USER_RESET_PAGINATION = 'ADMIN_TENANT_USER_RESET_PAGINATION'

export const ADMIN_EMISSION = 'ADMIN_EMISSION'
export const ADMIN_EMISSION_CONDITION = 'ADMIN_EMISSION_CONDITION'
export const ADMIN_EMISSION_RESET_CONDITION = 'ADMIN_EMISSION_RESET_CONDITION'
export const ADMIN_EMISSION_RESET_PAGINATION = 'ADMIN_EMISSION_RESET_PAGINATION'

export const ADMIN_TRANSPORT = 'ADMIN_TRANSPORT'
export const ADMIN_TRANSPORT_CONDITION = 'ADMIN_TRANSPORT_CONDITION'
export const ADMIN_TRANSPORT_RESET_CONDITION = 'ADMIN_TRANSPORT_RESET_CONDITION'
export const ADMIN_TRANSPORT_RESET_PAGINATION = 'ADMIN_TRANSPORT_RESET_PAGINATION'

export const ADMIN_DISPOSER = 'ADMIN_DISPOSER'
export const ADMIN_DISPOSER_CONDITION = 'ADMIN_DISPOSER_CONDITION'
export const ADMIN_DISPOSER_RESET_CONDITION = 'ADMIN_DISPOSER_RESET_CONDITION'
export const ADMIN_DISPOSER_RESET_PAGINATION = 'ADMIN_DISPOSER_RESET_PAGINATION'

export const ADMIN_MASTER_EMISSION = 'ADMIN_MASTER_EMISSION'
export const ADMIN_MASTER_EMISSION_CONDITION = 'ADMIN_MASTER_EMISSION_CONDITION'

export const ADMIN_INVOICE = 'ADMIN_INVOICE'
export const ADMIN_INVOICE_CONDITION = 'ADMIN_INVOICE_CONDITION'

export const ADMIN_MANIFEST_REPORT = 'ADMIN_MANIFEST_REPORT'
export const ADMIN_MANIFEST_REPORT_CONDITION = 'ADMIN_MANIFEST_REPORT_CONDITION'

export const ADMIN_ORDINANCE_CITY = 'ADMIN_ORDINANCE_CITY'
export const ADMIN_ORDINANCE_CITY_CONDITION = 'ADMIN_ORDINANCE_CITY_CONDITION'
export const ADMIN_ORDINANCE_CITY_RESET_CONDITION = 'ADMIN_ORDINANCE_CITY_RESET_CONDITION'
export const ADMIN_ORDINANCE_CITY_RESET_PAGINATION = 'ADMIN_ORDINANCE_CITY_RESET_PAGINATION'

export const ADMIN_EDI_REQUEST = 'ADMIN_EDI_REQUEST'
export const ADMIN_EDI_REQUEST_CONDITION = 'ADMIN_EDI_REQUEST_CONDITION'
export const ADMIN_EDI_REQUEST_RESET_CONDITION = 'ADMIN_EDI_REQUEST_RESET_CONDITION'
export const ADMIN_EDI_REQUEST_RESET_PAGINATION = 'ADMIN_EDI_REQUEST_RESET_PAGINATION'

